var React = require('react');

function IconUserResearchService (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11.4426","cy":"11.4426","r":"10.4426","stroke":"#00D664","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M20.8848 20.8853L25.9995 26","stroke":"#00D664","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M16.0468 8.29504L10.1403 15.1341L6.7207 12.0255","stroke":"#DDDDDD","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

IconUserResearchService.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = IconUserResearchService;

IconUserResearchService.default = IconUserResearchService;
